import React from 'react';

export default function ConfirmDialog({ dialog }) {
  const { message, confirmLabel, cancelLabel, danger, resolve } = dialog;
  return (
    <>
      <p className="text-[13px] text-[#444] leading-[1.6] mt-0 mb-[18px] whitespace-pre-line">
        {message}
      </p>
      <div className="flex justify-end gap-[8px]">
        <button type="button" className="btn" onClick={() => resolve(false)}>
          {cancelLabel}
        </button>
        <button
          type="button"
          autoFocus
          className={danger ? 'btn btn-danger' : 'btn btn-primary'}
          onClick={() => resolve(true)}
        >
          {confirmLabel}
        </button>
      </div>
    </>
  );
}
